import type { Theme } from '../../types/theme';

export const zapierTheme: Theme = {
  id: 'zapier',
  name: 'Zapier',
  description: 'Friendly automation platform with warm orange accents',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/zapier/DESIGN.md',
  visualKeywords: ['orange accent', 'automation', 'friendly', 'illustration-driven', 'connectors'],
  colors: {
    background: '#ffffff',
    surface: '#ffffff',
    surfaceElevated: '#ffffff',
    textPrimary: '#18181b',
    textSecondary: '#71717a',
    textMuted: '#71717a',
    border: '#e4e4e7',
    borderSubtle: '#dadadd',
    primary: '#ff4a00',
    primaryHover: '#eb3600',
    primaryActive: '#e12c00',
    accent: '#ff4a00',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'friendly',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
